<template>
  <div>
    <div class="div-title uppercase text-center font-title pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        HORSE LISTINGS - FOR SALE
      </h1>
    </div>

    <div class="flex flex-col lg:flex-row mb-24 relative">

      <div class="z-20 flex md:basis-1/4 left-[-2px] top-[100px] md:left-[0] z-50  md:top-[0] absolute  md:relative">
        <div  class="w-full" :class="{ 'block': showHorseListings, 'hidden md:block': !showHorseListings }">
          <div class="w-full p-3  shadow-2xl border-solid border border-black md:block bg-white" >
            <div class="mb-1 border-b border-b-gray-400 mb-4 pb-4">
              <h2 class="uppercase text-base border-b border-b-gray-400 tracking-wide font-['Open_Sans', 'sans_serif'] mb-4 pb-2 text-black font-bold"
              >
                Breeds
              </h2>
              <ul class=" text-veryDarkGray  mt-2">

                <li class="my-1.5 text-base" v-for="breed in breeds">
                  <label class="uppercase font-semibold relative pl-9 block group">{{ breed.name }}
                    <input type="checkbox" :checked="selected_breeds.includes(breed.name)" class="peer opacity-0"
                           @click="selectedBreeds(breed.name)">
                    <span
                        class="absolute top-0 left-0 h-6 w-6 bg-white border border-slate-400 group-hover:bg-black peer-checked:bg-red-800
                       peer-checked:after:relative peer-checked:after:block peer-checked:after:content-[''] peer-checked:after:left-0
                       peer-checked:after:top-1 peer-checked:after:h-2 peer-checked:after:border-white peer-checked:after:border-r-0
                       peer-checked:after:border-b-4 peer-checked:after:border-l-4 peer-checked:after:border-t-0 peer-checked:after:origin-center
                       peer-checked:after:-rotate-45">

                  </span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="mb-1 pb-4">
              <h2 class="uppercase text-base font-bold tracking-wide font-['Open_Sans', 'sans_serif'] text-black">
                Price</h2>
              <ul class="max-h-80 text-veryDarkGray my-2 ">

                <li class="my-1.5 text-base">
                  <label class="uppercase font-semibold relative pl-9 block group"> $ - Please Inquire
                    <input type="checkbox" class="peer opacity-0" @click="price = !price">
                    <span
                        class="absolute top-0 left-0 h-6 w-6 bg-white border border-slate-400 group-hover:bg-black peer-checked:bg-red-800
                       peer-checked:after:relative peer-checked:after:block peer-checked:after:content-[''] peer-checked:after:left-0
                       peer-checked:after:top-1 peer-checked:after:h-2 peer-checked:after:border-white peer-checked:after:border-r-0
                       peer-checked:after:border-b-4 peer-checked:after:border-l-4 peer-checked:after:border-t-0 peer-checked:after:origin-center
                       peer-checked:after:-rotate-45">

                  </span>
                  </label>
                </li>

              </ul>
              <div class="flex">
                <button @click="resetFilter()"
                        class="text-darkRed hover:opacity-70 hover:text-darkBlue underline underline-offset-4">
                  reset
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="md:hidden w-10 h-8 bg-orange-700 ml-1 flex items-center justify-center"


             @click="showHorseListings =!showHorseListings">
          <div v-if="showHorseListings">
            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-alt-circle-left"
                 class="w-7 h-7" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="#ffffff"
                    d="M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"></path>
            </svg>
          </div>
          <div v-else>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="w-7 h-5" role="img"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="#ffffff"
                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full md:basis-3/4 px-3">
        <div class=" flex flex-col sm:flex-row justify-between bg-black items-center px-4 py-2.5 mb-2">
          <div class="w-full  sm:w-[43%] sm:mr-2">
            <input v-model="filter" class="py-1 px-3 border focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 w-full sm:max-w-[250px] sm:mr-3 sm:auto mb-2 sm:mb-0" type="text" placeholder="Search">
          </div>
          <div class="flex justify-between w-full sm:w-[54%]">
            <div class="flex space-x-2 justify-center w-auto mb-2 sm:mb-0">
              <NuxtLink to="/for-sale-gallery/add-horse-for-sale"
                        class="flex justify-center items-center px-6 py-2 bg-themeRed text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-white hover:text-black
            focus:shadow-lg w-full focus:outline-none focus:ring-0 active:bg-gray-900 active:shadow-lg transition duration-150 uppercase text-tiny ease-in-out"
              >
                <div class="">
                  add horse for sale
                </div>
              </NuxtLink>
            </div>
            <div class="flex justify-items-center align-center mb-2 sm:mb-0">
              <admin-control
                  v-model="perPage"
                  :options="pageOptions"
                  type="select"
                  name="select"
              />
            </div>
          </div>
        </div>
        <div class="grid-layout mb-5">
          <div class="flex flex-row flex-wrap">
            <div v-if="itemsPaginated.length > 0" class="bg-white p-1 sm:p-4 text-center relative w-[48%] lg:w-[32%] m-[1%] lg:m-[0.5%] flex flex-col justify-between drop-shadow-md" v-for="(item, index) in itemsPaginated">
              <div class="box-img mb-1">
                <NuxtLink :to="'/view/'+item.horse_url">
                  <template v-if="index<1">
                    <nuxt-img
                        preload
                        width="236"
                        height="310"
                        format="webp"
                        :alt="item.horse_name"
                        :src="siteURL +  '/storage/images/horse-listings/' +
                              horse_path + '/' +
                              item.path +
                              '/' +
                              item.cover"/>
                  </template>
                  <template v-else>
                    <nuxt-img
                        width="236"
                        height="310"
                        format="webp"
                        :alt="item.horse_name"
                        :src="siteURL +  '/storage/images/horse-listings/' +
                              horse_path + '/' +
                              item.path +
                              '/' +
                              item.cover"/>
                  </template>
                </NuxtLink>
              </div>
              <div class="flex flex-col relative py-2.5 px-4">
                <div class="list-box text-left">
                  <h2 class="custom-h2 leading-4 mb-2.5">
                    <NuxtLink
                        :to="'/view/'+item.horse_url"
                        class="
                        underline
                        mb-2.5
                        font-medium
                        text-2xl
                        text-black
                        font-medium
                        hover:text-gray-900
                        min-h-[32px] sm:min-h-[auto]
                        flex
                      "
                    ><p>{{ item.horse_name }}</p></NuxtLink>
                  </h2>
                  <div>
                    <ul class="mb-3">
                      <li class="text-base">{{ item.breed }}</li>
                      <li class="text-base">{{ item.stable }}</li>
                      <li class="text-base">{{ item.price}}</li>
                    </ul>

                    <NuxtLink :to="'/view/'+item.horse_url"
                              class="text-sm font-semibold  border border-black px-2 py-2 uppercase hover:text-white hover:bg-black hover:decoration-[0px]">
                      see more
                    </NuxtLink>
                  </div>
                </div>
                <div class="absolute top-0 left-0 w-[4px] h-[30%] border-black bg-black border"></div>
              </div>
            </div>
            <div v-else class="card-gallery">
              <div v-if="selected_breeds.length > 0">
                No results have been found, please refine your research and try again.
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end sm:mb-0">
          <nav aria-label="Page navigation example">
            <admin-level>
              <admin-pagination
                  v-model="currentPage"
                  :pagesList="pagesList"
              />
            </admin-level>
          </nav>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import {http} from "~/utils/http";
import {computed, ref, watch} from "vue";
import useDebouncedRef from '~/composables/useDebouncedRef'
import {useSiteURL} from "../../composables/state";

const showHorseListings = ref(false);
const filter = useDebouncedRef('', 500);
const siteURL = useSiteURL();

const perPage = ref(12);
const currentPage = ref(0);
const pageOptions = ref([
  {id: 12, name: 12},
  {id: 24, name: 24},
  {id: 60, name: 60},
  {id: 120, name: 120},
]);
const itemsPaginated = computed(() => {
      let showItems = items.value;

      if (selected_breeds.value.length > 0) {
        showItems = horses.value.filter((item) => selected_breeds.value.includes(item.breed)
            && ((price.value && item.price === '$ please inquire') || !price.value)
        );
      }

      return showItems.slice(
          perPage.value * currentPage.value,
          perPage.value * (currentPage.value + 1)
      )
    }
);
const numPages = computed(() => Math.ceil(items.value.length / perPage.value));
const currentPageHuman = computed(() => currentPage.value + 1);
const pagesList = computed(() => {
  const pagesList = [];

  for (let i = 0; i < numPages.value; i++) {
    pagesList.push(i);
  }

  return pagesList;
});
const ready = ref(false);
const horses = ref([]);
const breeds = ref([]);
const items = ref([]);
const horse_path = ref('')
const selected_breeds = ref([]);
const price = ref(false);

watch(filter, (value) => {
  items.value = horses.value.filter((item) =>
      item.horse_name.toLowerCase().includes(value.toLowerCase())
      || item.breed.toLowerCase().includes(value.toLowerCase())
      || item.stable.toLowerCase().includes(value.toLowerCase())
  );
  currentPage.value = 0;
});

const selectedBreeds = async (name) => {
  let i = selected_breeds.value.map(item => item).indexOf(name);
  if (i < 0) {
    selected_breeds.value.push(name);
  } else {
    selected_breeds.value.splice(i, 1);
  }
}

const resetFilter = async () => {
  selected_breeds.value = [];
  price.value = false;
  filter.value = '';
}

const getData = async (id) => {
  items.value = [];
  currentPage.value = 0;
  try {
    await http
        .get("/api/horse-sale", {
          params: {
            status: id,
            type: 'sales'
          }
        })
        .then((response) => {
          horse_path.value = response.data.path;
          response.data.horses.forEach((horse) => {
            let first_name = horse.user ? horse.user.first_name : '';
            let last_name = horse.user ? horse.user.last_name : '';
            let user_id = horse.user ? horse.user.id : '';
            let expiration_date = '';
            if (horse.subscription) {
              expiration_date = new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              }).format(new Date(horse.subscription.expiration_date));
            }
            items.value.push({
              id: horse.id,
              horse_name: horse.horse_name,
              user: first_name + ' ' + last_name,
              user_id: user_id,
              breed: horse.breed.name,
              created_at: new Intl.DateTimeFormat('default', {    timeZone: 'utc',
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              }).format(new Date(horse.created_at)),
              expiration_date: expiration_date,
              status: horse.subscription ? horse.subscription.status : '',
              registry_number: horse.registry_number ? horse.registry_number : '',
              stable: horse.stable ? horse.stable : '',
              price: horse.price ? horse.price : '',
              path: horse.path ? horse.path : '',
              cover: horse.cover ? horse.cover : '',
              horse_url: horse.horse_url,
            })
          })
          horses.value = items.value;
        });
  } catch (e) {
    console.log(e);
  }
}

const getBreeds = async () => {
  try {
    await http
        .get("/api/results/breed")
        .then((response) => {
          response.data.forEach((breed) => {
            breeds.value.push({
              id: breed.id,
              name: breed.name,
            })
          })
        });
  } catch (e) {
    console.log(e);
  }
}

Promise.all([getData(2), getBreeds()]);

</script>
